<template>
  <div class="completeInformation">
    <div class="completeInformation-head">基本信息</div>
    <div>
      <el-form ref="form" :model="form" label-width="148px" :rules="addRules" style="display: flex;flex-wrap: wrap;">
        <el-form-item label="供应商分类" style="width: 30%;" prop="s_type_id">
          <!-- <el-cascader style="width: 100%;" v-model="form.s_type_id" :options="supplierList" @change="handleChange"
            :props="{ value: 'id', label: 'name', children: 'children', multiple: true }"></el-cascader> -->
          <el-select style="width: 100%;" v-model="form.s_type_id" placeholder="请选择" multiple @change="handleChange">
            <el-option-group v-for="group in supplierList" :key="group.id" :label="group.name">
              <el-option v-for="item in group.children" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称" style="width: 30%;" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="单位地址" style="width: 30%;" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="成立时间" style="width: 30%;" prop="found_time">
          <el-date-picker style="width: 100%;" type="date" v-model="form.found_time" value-format="yyyy-MM-dd"
            placeholder="选择成立时间" />
        </el-form-item>
        <el-form-item label="统一社会信用代码" style="width: 30%;" prop="unique_code">
          <el-input v-model="form.unique_code"></el-input>
        </el-form-item>
        <el-form-item label="注册资金(单位：万)" style="width: 30%;" prop="scale">
          <el-input v-model="form.scale"></el-input>
        </el-form-item>
        <!-- <el-form-item label="注册资金(单位：万)" style="width: 30%;">
            <el-select v-model="form.scale" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in money"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-form-item> -->
        <el-form-item label="法定代表人" style="width: 30%;" prop="legal">
          <el-input v-model="form.legal"></el-input>
        </el-form-item>
        <el-form-item label="联系人" style="width: 30%;" prop="agent">
          <el-input v-model="form.agent"></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" style="width: 30%;" prop="mobile">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="企业性质" style="width: 30%;" prop="quality">
          <el-select v-model="form.quality" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in qyxzList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业资质" style="width: 30%;" prop="qualification">
          <el-input type="textarea" v-model="form.qualification" placeholder="若有请填写，“，”分开"></el-input>
        </el-form-item>
        <!-- <el-form-item label="主营产品" style="width: 30%;">
            <el-input v-model="form.pro_type"></el-input>
          </el-form-item> -->
        <el-form-item label="经营范围" style="width: 30%;" prop="support">
          <el-input v-model="form.support"></el-input>
        </el-form-item>
        <el-form-item label="主营产品/服务" style="width: 30%;" prop="pro_type">
          <el-input v-model="form.pro_type"></el-input>
        </el-form-item>
        <!-- <el-form-item label="提供发票类型" style="width: 30%;">
            <el-input v-model="form.invoice_type"></el-input>
          </el-form-item> -->
        <el-form-item label="提供发票类型" style="width: 30%;" prop="invoice_type">
          <el-select v-model="form.invoice_type" placeholder="请选择" multiple style="width: 100%;">
            <el-option v-for="item in invoice_cate" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="合作记录" style="width: 30%;">
            <el-input v-model="form.coop_record"></el-input>
          </el-form-item>
          <el-form-item label="推荐部门" style="width: 30%;">
            <el-input v-model="form.recommend_dept"></el-input>
          </el-form-item> -->
        <el-form-item label="合作记录" style="width: 30%;">
          <el-input v-model="form.coop_record"></el-input>
        </el-form-item>
        <el-form-item label="代表工程" style="width: 30%;">
          <el-input v-model="form.engineering"></el-input>
        </el-form-item>
        <el-form-item label="纳税人身份信息" style="width: 30%;" prop="shui_type">
          <el-select v-model="form.shui_type" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in shui_type_list" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱" style="width: 30%;" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="股东|股比(%)" style="width: 30%;" prop="gudong">
          <el-input v-model="form.gudong" type="textarea" placeholder="例：xxxx公司|10%（多条请换行）"></el-input>
        </el-form-item>
        <el-form-item label="合作记录附件" style="width: 30%;">
          <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="success5" :on-remove="remove5"
            :before-upload="beforeUpload" :file-list="form.coop_file" :limit="10" :multiple="true"
            :headers="{ token: token }">
            <el-button type="primary" size="small"><i class="el-icon-plus" />上传</el-button>
            <div slot="tip" class="el-upload__tip" style="line-height: 16px;">
              （请上传与科技馆过往合作记录支撑文件，如合同、中标通知书、验收报告等）</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="代表工程附件" style="width: 30%;">
          <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="success4" :on-remove="remove4"
            :before-upload="beforeUpload" :file-list="form.engineer_file" :limit="10" :multiple="true"
            :headers="{ token: token }">
            <el-button type="primary" size="small"><i class="el-icon-plus" />上传</el-button>
            <div slot="tip" class="el-upload__tip" style="line-height: 16px;">
              （请上传贵司过往代表工程/项目支撑文件，如合同、中标通知书、验收报告等）</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="上传荣誉" style="width: 30%;">
          <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="success1" :on-remove="remove1"
            :before-upload="beforeUpload" :file-list="form.honor" :limit="10" :multiple="true"
            :headers="{ token: token }">
            <el-button type="primary" size="small"><i class="el-icon-plus" />上传</el-button>
            <div slot="tip" class="el-upload__tip" style="line-height: 16px;">
              (请上传贵司过往荣誉支撑文件)</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="上传营业执照" style="width: 30%;" prop="business">
          <el-input v-model="form.business" v-show="false"></el-input>
          <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="success2" :on-remove="remove2"
            :file-list="form.business" :limit="10" :multiple="true" :before-upload="beforeUpload"
            :headers="{ token: token }">
            <el-button type="primary" size="small"><i class="el-icon-plus" />上传</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item label="上传资质证件" style="width: 30%;">
          <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="success3" :on-remove="remove3"
            :file-list="form.qd" :limit="10" :multiple="true" :before-upload="beforeUpload" :headers="{ token: token }">
            <el-button type="primary" size="small"><i class="el-icon-plus" />上传</el-button>
            <div slot="tip" class="el-upload__tip" style="line-height: 16px;">
              （若有，请上传资质文件证明材料）</div>

          </el-upload>
        </el-form-item>
        <el-form-item label="上传信用报告" style="width: 30%;" prop="xinyong">
          <el-input v-model="form.xinyong" v-show="false"></el-input>
          <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="successCredit"
            :on-remove="removeCredit" :file-list="form.xinyong" :limit="10" :multiple="true" :before-upload="beforeUpload"
            :headers="{ token: token }">
            <el-button type="primary" size="small"><i class="el-icon-plus" />上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <el-button @click="previewBtn">预览</el-button>
      <el-button type="primary" @click="save">提交审核</el-button>
    </div>
    <el-dialog title="预览" :visible.sync="yulanShow" width="80%">
      <div>
        <el-form ref="form" :disabled="true" :model="form" label-width="148px" style="display: flex;flex-wrap: wrap;">
          <el-form-item label="供应商分类" style="width: 30%;">
            <!-- <el-cascader style="width: 100%;" v-model="form.s_type_id" :options="supplierList" @change="handleChange"
              :props="{ value: 'id', label: 'name', children: 'children', multiple: true }"></el-cascader> -->
            <el-select style="width: 100%;" v-model="form.s_type_id" placeholder="请选择" multiple @change="handleChange">
              <el-option-group v-for="group in supplierList" :key="group.id" :label="group.name">
                <el-option v-for="item in group.children" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称" style="width: 30%;">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="单位地址" style="width: 30%;">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="成立时间" style="width: 30%;">
            <el-date-picker style="width: 100%;" v-model="form.found_time" value-format="yyyy-MM-dd" type="date"
              placeholder="选择成立时间" />
          </el-form-item>
          <el-form-item label="统一社会信用代码" style="width: 30%;">
            <el-input v-model="form.unique_code"></el-input>
          </el-form-item>

          <el-form-item label="注册资金(单位：万)" style="width: 30%;">
            <el-input v-model="form.scale"></el-input>
          </el-form-item>
          <!-- <el-form-item label="注册资金(单位：万)" style="width: 30%;">
              <el-select v-model="form.scale" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in money"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item> -->
          <el-form-item label="法定代表人" style="width: 30%;">
            <el-input v-model="form.legal"></el-input>
          </el-form-item>
          <el-form-item label="联系人" style="width: 30%;">
            <el-input v-model="form.agent"></el-input>
          </el-form-item>
          <el-form-item label="联系人手机号" style="width: 30%;">
            <el-input v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item label="企业性质" style="width: 30%;" prop="quality">
            <el-select v-model="form.quality" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in qyxzList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业资质" style="width: 30%;">
            <el-input type="textarea" v-model="form.qualification"></el-input>
          </el-form-item>
          <!-- <el-form-item label="主营产品" style="width: 30%;">
              <el-input v-model="form.pro_type"></el-input>
            </el-form-item> -->
          <el-form-item label="经营范围" style="width: 30%;" prop="support">
            <el-input v-model="form.support"></el-input>
          </el-form-item>
          <el-form-item label="主营产品/服务" style="width: 30%;" prop="pro_type">
            <el-input v-model="form.pro_type"></el-input>
          </el-form-item>
          <!-- <el-form-item label="提供发票类型" style="width: 30%;">
              <el-input v-model="form.invoice_type"></el-input>
            </el-form-item> -->
          <el-form-item label="提供发票类型" style="width: 30%;">
            <el-select v-model="form.invoice_type" multiple placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in invoice_cate" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="合作记录" style="width: 30%;">
              <el-input v-model="form.coop_record"></el-input>
            </el-form-item>
            <el-form-item label="推荐部门" style="width: 30%;">
              <el-input v-model="form.recommend_dept"></el-input>
            </el-form-item> -->
          <el-form-item label="合作记录" style="width: 30%;">
            <el-input v-model="form.coop_record"></el-input>
          </el-form-item>
          <el-form-item label="代表工程" style="width: 30%;">
            <el-input v-model="form.engineering"></el-input>
          </el-form-item>
          <el-form-item label="纳税人身份信息" style="width: 30%;">
            <el-select v-model="form.shui_type" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in shui_type_list" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮箱" style="width: 30%;" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="股东|股比(%)" style="width: 30%;">
            <el-input v-model="form.gudong" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="合作记录附件" style="width: 30%;">
            <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="success5" :on-remove="remove5"
              :before-upload="beforeUpload" :file-list="form.coop_file" :limit="10" :multiple="true"
              :headers="{ token: token }">
              <el-button type="primary"><i class="el-icon-plus" />上传</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="代表工程附件" style="width: 30%;">
            <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="success4" :on-remove="remove4"
              :before-upload="beforeUpload" :file-list="form.engineer_file" :limit="10" :multiple="true"
              :headers="{ token: token }">
              <el-button type="primary"><i class="el-icon-plus" />上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传荣誉" style="width: 30%;">
            <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="success1" :on-remove="remove1"
              :before-upload="beforeUpload" :file-list="form.honor" :limit="10" :multiple="true"
              :headers="{ token: token }">
              <el-button type="primary"><i class="el-icon-plus" />上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传营业执照" style="width: 30%;" prop="business">
            <el-input v-model="form.business" v-show="false"></el-input>
            <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="success2" :on-remove="remove2"
              :file-list="form.business" :limit="10" :multiple="true" :before-upload="beforeUpload"
              :headers="{ token: token }">
              <el-button type="primary"><i class="el-icon-plus" />上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传资质证件" style="width: 30%;">
            <el-upload action="`http://srm.xmstm.com.cn/api/Upload/files`" :on-success="success3" :on-remove="remove3"
              :file-list="form.qd" :limit="10" :multiple="true" :before-upload="beforeUpload" :headers="{ token: token }">
              <el-button type="primary"><i class="el-icon-plus" />上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传信用报告" style="width: 30%;">
            <el-upload action="http://srm.xmstm.com.cn/api/Upload/files" :on-success="successCredit"
              :on-remove="removeCredit" :file-list="form.xinyong" :limit="10" :multiple="true"
              :before-upload="beforeUpload" :headers="{ token: token }">
              <el-button type="primary" size="small"><i class="el-icon-plus" />上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="yulanShow = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api5, api10, api12 } from '@/api/index.js'
export default {
  props: {
    isAuthCheck: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object,
      default: () => { }
    }

  },
  data() {
    let checkPhone = (rule, value, callback) => { // 手机号验证
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3456789]\d{9}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    let checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }
    return {
      yulanShow: false,
      token: '',
      addRules: {
        s_type_id: [{ required: true, message: "请选择供应商分类", trigger: "change" }],
        name: [{ required: true, message: "请填写公司名称", trigger: "blur" }],
        scale: [{ required: true, message: "请填写注册资金", trigger: "blur" }],
        legal: [{ required: true, message: "请填写法定代表人", trigger: "blur" }],
        agent: [{ required: true, message: "请填写联系人", trigger: "blur" }],
        unique_code: [{ required: true, message: "请填写统一社会信用代码", trigger: "blur" }],
        address: [{ required: true, message: "请填写单位地址", trigger: "blur" }],
        support: [{ required: true, message: "请填写经营范围", trigger: "blur" }],
        pro_type: [{ required: true, message: "请填写主营产品/服务", trigger: "blur" }],
        quality: [{ required: true, message: "请选择企业性质", trigger: "change" }],
        found_time: [{ required: true, message: "请选择成立时间", trigger: "change" }],
        shui_type: [{ required: true, message: "请选择纳税人身份信息", trigger: "change" }],
        invoice_type: [{ required: true, message: "请选择提供发票类型", trigger: "change" }],
        qualification: [{ required: true, message: "请填写企业资质", trigger: "blur" }],
        business: [{ required: true, message: "请上传营业执照", trigger: "change" }],
        gudong: [{ required: true, message: "请输入股东|股比", trigger: "change" }],
        xinyong: [{ required: true, message: "请上传信用报告", trigger: "change" }],
        mobile: [
          { required: true, message: "请输入正确手机号", trigger: "blur" },
          { validator: checkPhone, trigger: 'blur' }
        ],
        email: [
          { required: true, message: "请输入正确的邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: 'blur' }
        ],
      },

      money: [
        { value: '0-50', label: '0-50' },
        { value: '51-100', label: '51-100' },
        { value: '101-500', label: '101-500' },
        { value: '501-1000', label: '501-1000' },
        { value: '1000以上', label: '1000以上' }
      ],
      invoice_cate: [
        { value: 1, label: '增值税专用发票' },
        { value: 2, label: '普通发票' },
        // { value: '定额发票', label: '定额发票' },
      ],
      shui_type_list: [
        {
          name: '一般纳税人',
          id: '一般纳税人'
        },
        {
          name: '小规模纳税人',
          id: '小规模纳税人'
        },
      ],
      form: {
        id: '', // 供应商分类id
        title: '', // 
        s_type_id: [], // 
        name: '', // 公司名称
        address: '', // 单位地址
        found_time: '', // 成立时间格式 2024-01-22 12:00:00
        unique_code: '', // 统一社会信用代码
        scale: '', // 注册资金(单位：万)
        legal: '', // 法定代表人
        agent: '', // 联系人
        mobile: '', // 联系人手机号
        quality: '', // 企业性质
        qualification: '无', // 企业资质
        // pro_type: '', // 主营产品
        support: '', // 经营范围
        invoice_type: [], // 提供发票类型
        coop_record: '', // 合作记录
        recommend_dept: '', // 推荐部门
        engineering: '', // 代表工程
        email: '', // 邮箱
        engineer_file: [],
        coop_file: [],
        honor: [], // 上传荣誉
        business: [], // 上传营业执照
        qd: [],// 上传资质证件
        shui_type: '',
        xinyong: []//信用报告
      },
      supplierList: [], // 供应商分类列表
      qyxzList: []// 企业性质
    }
  },
  mounted() {
    this.token = JSON.parse(localStorage.getItem('userInfo')).token
    this.form.id = JSON.parse(localStorage.getItem('userInfo')).id
    this.get_supplier()
    api12({ id: this.form.id }).then(res => {
      if (res.data.code === 1) {
        this.qyxzList = res.data.data.lists
      } else {
        this.$message.error(res.data.msg)
      }
    })


  },
  methods: {
    getUserData() {
      if (this.isAuthCheck) {
        this.form = this.userData
        this.$set(this.form, 'qualification', this.form.qualification ? this.form.qualification : '无')
        this.$set(this.form, 'xinyong', this.form.xinyong ? this.form.xinyong : [])
        this.$forceUpdate()
      }
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
      const whiteList = ['doc', 'docx', 'pdf', 'jpg', 'png']
      if (!whiteList.includes(fileSuffix)) {
        this.$message.error('上传文件只能是 （.doc, .docx, .pdf, .jpg, .png） 格式！')
        return false
      }
      // return true
    },
    handleChange(value) {
      console.log(value)
      // this.form.type = this.form.type[1]
    },
    get_supplier() {
      api10().then(res => {
        if (res.data.code === 1) {
          this.supplierList = res.data.data
          this.getUserData()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    previewBtn() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.yulanShow = true;
        } else {
          this.$message.warning('请正确填写！')
          return false;
        }
      });
    },

    save() {
      let form = JSON.parse(JSON.stringify(this.form))
      form.engineer_file = this.setFileList(form.engineer_file)
      form.coop_file = this.setFileList(form.coop_file)
      form.honor = this.setFileList(form.honor)
      form.business = this.setFileList(form.business)
      form.qd = this.setFileList(form.qd)
      form.xinyong = this.setFileList(form.xinyong)
      this.$refs["form"].validate((valid) => {
        if (valid) {
          api5(form).then(res => {
            if (res.data.code === 1) {
              this.$message.success('保存成功')
              location.reload()
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.$message.warning('请正确填写！')
          return false;
        }
      });

    },
    setFileList(fileArr) {
      let newData = []
      if (fileArr && fileArr.length > 0) {
        fileArr.forEach(e => {
          newData.push(e.url)
        });
      }
      return newData.join(',')

    },
    handleClose() {

    },
    remove2(file, fileList) {
      this.form.business = fileList
    },
    remove3(file, fileList) {
      this.form.qd = fileList
    },
    remove4(file, fileList) {
      this.form.engineer_file = fileList
    },
    remove5(file, fileList) {
      this.form.coop_file = fileList
    },
    removeCredit(file, fileList) {
      this.form.xinyong = fileList
    },
    remove1(file, fileList) {
      this.form.honor = fileList
    },
    success1(response, file) {
      this.form.honor.push(response.data)
      this.$message.success('上传成功')
    },
    success2(response, file) {
      this.form.business.push(response.data)
      this.$message.success('上传成功')
    },
    success3(response, file) {
      this.form.qd.push(response.data)
      this.$message.success('上传成功')
    },
    success4(response, file) {
      this.form.engineer_file.push(response.data)
      this.$message.success('上传成功')
    },
    success5(response, file) {
      this.form.coop_file.push(response.data)
      this.$message.success('上传成功')
    },
    successCredit(response, file) {
      this.form.xinyong.push(response.data)
      this.$message.success('上传成功')
    }
  }
}

</script>

<style>
::v-deep .el-form-item {
  width: 30%;
}

.completeInformation-head {
  height: 56px;
  padding: 16px 24px;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
}

.completeInformation {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/completeInformation.vue